import { useCallback } from 'react';
import type { ViewId } from 'balus-common';
import { toast } from 'react-hot-toast';
import { ClipboardUtils } from '@framework/ClipboardUtils';
import { useTranslation } from 'react-i18next';
type Handler = () => void;

export const useCopyViewUrl = (viewId: ViewId): Handler => {
  const { t } = useTranslation();
  return useCallback(async () => {
    const query = new URLSearchParams();

    query.set('targetView', viewId);
    const url = `${window.location.origin}${window.location.pathname}?${query.toString()}`;

    try {
      await ClipboardUtils.copy(url);
      toast.success(t('common.message.copySuccess'));
    } catch (e) {
      console.warn('クリップボードへのコピーに失敗しました', e);
      toast.error(t('common.message.copyFailed'));
    }
  }, [t, viewId]);
};
